/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {Navbar} from './Navbar'
import {useAuth} from '../../../../app/modules/auth'

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  const {currentUser} = useAuth()
  if (!config.app?.header?.display) {
    return null
  }

  return (
    <div id='kt_app_header' className='app-header'>
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container flex-lg-grow-1',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                id='kt_app_sidebar_mobile_toggle'
              >
                <KTIcon iconName='abstract-14' className=' fs-1' />
              </div>
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to='/apps/user-management/users' className='d-lg-none'>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-small.svg')}
                    className='h-30px'
                  />
                </Link>
              </div>
            </div>
          </>
        )}

        {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to='/dashboard'>
              {config.layoutType !== 'dark-header' ? (
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/default.svg')}
                  className='h-20px h-lg-30px app-sidebar-logo-default'
                />
              ) : (
                <>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-small-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )}
            </Link>
          </div>
        )}

        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-center justify-content-between flex-lg-grow-1 flex-wrap'
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <Header />
              </div>
            )}
          {/* Customer Info Banner - desktop: inline in header, mobile: full width row below */}
          {currentUser && (
            <div className='d-none d-md-flex align-items-center gap-2 py-1 px-3 rounded bg-light-primary mx-auto mt-1' style={{height: '32px'}}>
              <span className='fw-bold text-gray-700 fs-7'>
                {(currentUser as any).name || ''}
              </span>
              <span className='text-muted fs-8'>|</span>
              <span className='fw-semibold text-gray-600 fs-7'>
                {(currentUser as any).city || ''}
              </span>
              <span className='text-muted fs-8'>|</span>
              <span className='badge badge-light-primary fs-8 py-1'>
                {(currentUser as any).customer_code || ''}
              </span>
            </div>
          )}
          {currentUser && (
            <div className='d-flex d-md-none w-100 justify-content-center order-last mt-2 mb-1'>
              <div className='d-flex align-items-center gap-2 py-1 px-3 rounded bg-light-primary'>
                <span className='fw-bold text-gray-700 fs-8'>
                  {(currentUser as any).name || ''}
                </span>
                <span className='text-muted fs-9'>|</span>
                <span className='fw-semibold text-gray-600 fs-8'>
                  {(currentUser as any).city || ''}
                </span>
                <span className='text-muted fs-9'>|</span>
                <span className='badge badge-light-primary fs-9 py-1'>
                  {(currentUser as any).customer_code || ''}
                </span>
              </div>
            </div>
          )}
          <Navbar />
        </div>
      </div>
    </div>
  )
}
